import React from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../../../common/head-container';

const AlreadyRegistered = ({
  setScreenNumber,
  telegramLink,
  handleNextButtonClick
}) => {
  const handleContentButtonClick = () => {
    sessionStorage.setItem('r_b', 'false');
    handleNextButtonClick();
  };

  return (
    <div
      className={styles.container}
      style={{ backgroundImage: 'url("/images/26ua-lm-lfc-auth/bg.png")' }}
    >
      <div className={styles.headContainer}>
        <HeadContainer
          setScreenNumber={setScreenNumber}
          telegramOnly
          customTelegramLink={telegramLink}
        />
      </div>
      <div className={styles.content}>
        <p className={styles.title}>Супер!</p>
        <p className={styles.description}>
          Бачимо, що ти вже підтвердив свій вік раніше.
          <br></br>
          <br></br>
          Не гай часу, переходь до контенту.
        </p>
        <img
          className={styles.shapes}
          src="/images/26ua-lm-lfc-auth/super-shapes.svg"
          alt=""
        />
        <button
          className={styles.nextButton}
          onClick={handleContentButtonClick}
        >
          <img
            className={styles.buttonGlow}
            src="/images/26ua-lm-lfc-auth/button-glow.svg"
            alt=""
          />
          <span>Далі</span>
        </button>
      </div>
    </div>
  );
};

export default AlreadyRegistered;
